// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".property-name.svelte-1fmzxo8{margin-left:1em}.required.svelte-1fmzxo8:before{content:\"!\";font-weight:bold;color:var(--color-red)}", ""]);
// Exports
module.exports = exports;
